import mainComponent from '@/layouts/main/Main.vue'

export default [{
  path: '/impressao',
  component: mainComponent,
  title: 'Impressão',
  children: [{
    path: '/',
    name: 'printer-form',
    component: () => import('@/views/printer/PrinterForm.vue'),
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Impressão', active: true },
      ],
      pageTitle: 'Impressão',
      rule: 'editor',
    },
  }],
}, ];